import React from 'react';
import { Box, Grid2, Typography } from '@mui/material';

export default function AboutMe({ darkMode }) {
    return (
        <Grid2
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            height={`calc(100vh)`}
            textAlign="center"
            sx={{
                px: 1,
                backgroundColor: darkMode ? '#0E0E0F55' : '#F5F5F5CB',
            }}
        >
            <Grid2 item xs={12} md={8} lg={6} xl={6}>
                <Box
                    component="section"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        margin: 1,
                    }}
                    maxWidth={800}
                >
                    <Typography variant="h2" fontWeight={500}>
                        Sobre mim
                    </Typography>
                    <Typography variant="h5" fontWeight={500} align="justify">
                        Atualmente trabalho com Engenharia de Software desenvolvendo o PaaS interno
                        do Grupo OLX, que engloba empresas como OLX Brasil, Zap Imóveis e VivaReal.
                        Desenvolvo desde interfaces no front-end com ReactJS, passando por soluções
                        no back-end com Typescript e NodeJS, e integrando com a cloud utilizando AWS
                        e Kubernetes, buscando melhorar a experiência do desenvolvedor ao criar
                        aplicações escaláveis. Sou apaixonado por tecnologia e inovação, e estou
                        sempre buscando aprender coisas novas. 🚀
                    </Typography>
                </Box>
            </Grid2>
        </Grid2>
    );
}
